import TemplatesModal from '../TemplatesModal'
import LShapeScreen from './screens/LShapeScreen'
import RectangleScreen from './screens/RectangleScreen'

const screens = [
  {
    key: 'rectangle',
    title: 'Rectangle',
    component: RectangleScreen,
    icon: 'rectangle' as const,
  },
  { key: 'l-shape', title: 'L-Shape', component: LShapeScreen, icon: 'lshape' as const },
]

const ShapeTemplatesModal = () => {
  return <TemplatesModal title="Shape Templates" screens={screens} />
}

export default ShapeTemplatesModal
